import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

export interface WipDialogDetail {
  label: string;
  value: string;
}

@Component({
  selector: 'app-wip-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './wip-dialog.component.html',
  styleUrls: ['./wip-dialog.component.scss'],
})
export class WipDialogComponent {
  @Input() visible = false;
  @Input() title = 'In arrivo';
  @Input() message = 'Stiamo lavorando a questa funzionalità';
  @Input() subtitle = 'Resta sintonizzato!';
  @Input() iconClass = 'pi pi-hourglass';
  @Input() ctaLabel = 'Ho capito';
  @Input() dialogWidth = '92vw';
  @Input() maxWidth = '440px';
  /** Variante visuale: default | document */
  @Input() variant: 'default' | 'document' = 'default';
  @Input() details: WipDialogDetail[] = [];

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onClose = new EventEmitter<void>();

  get hasDetails(): boolean {
    return this.details?.length > 0;
  }

  onDialogHide(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.onClose.emit();
  }

  onCloseClick(): void {
    this.visible = false;
  }
}
